export enum Currencies {
	EUR = "EUR",
	USD = "USD",
	RUB = "RUB",
	CNY = "CNY"
}
